import { render, staticRenderFns } from "./SelectBoxTabFocus.vue?vue&type=template&id=648a3a30&scoped=true"
import script from "./SelectBoxTabFocus.vue?vue&type=script&lang=js"
export * from "./SelectBoxTabFocus.vue?vue&type=script&lang=js"
import style0 from "./SelectBoxTabFocus.vue?vue&type=style&index=0&id=648a3a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a3a30",
  null
  
)

export default component.exports